import { render, staticRenderFns } from "./MoblieHome.vue?vue&type=template&id=4bf666ec&scoped=true"
import script from "./MoblieHome.vue?vue&type=script&lang=js"
export * from "./MoblieHome.vue?vue&type=script&lang=js"
import style0 from "./MoblieHome.vue?vue&type=style&index=0&id=4bf666ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf666ec",
  null
  
)

export default component.exports